import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';

import { DefaultButton } from 'common/components';

import { reopenIssueBackoffice } from '../../_redux';

import staticStyles from './style';

const ReopenIssueForm = ({ issueId, handleSubmit, reopenIssueBackoffice, dispatch, submitting, error }) => {
  const submit = useMemo(
    () =>
      handleSubmit(() =>
        reopenIssueBackoffice(
          {
            issueId,
          },
          dispatch
        )
      ),
    [handleSubmit, issueId, dispatch]
  );
  return (
    <div className="RejectModal__content">
      <form className="ReopenIssueForm" onSubmit={submit}>
        <div className="ReopenIssueForm__btns">
          <DefaultButton
            butColor="error"
            textId="justReopen"
            type="submit"
            loading={submitting}
            disabled={submitting}
          />
        </div>
        {error && <strong>{error}</strong>}
      </form>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

ReopenIssueForm.propTypes = {
  issueId: PropTypes.number.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  reopenIssueBackoffice: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
};

ReopenIssueForm.defaultProps = {
  error: '',
};

export default compose(
  connect(null, {
    reopenIssueBackoffice: search => reopenIssueBackoffice.request(search),
  }),
  reduxForm({
    form: 'ReopenIssueForm',
    onSubmitSuccess: (result, dispatch, props) => {
      props.onSubmitSuccess();
    },
  })
)(ReopenIssueForm);
export { ReopenIssueForm };
